// extracted by mini-css-extract-plugin
module.exports = {"events__cards":"styles_events__cards__2Hg2S","event__list__events":"styles_event__list__events__39EWU","notification__pagination":"styles_notification__pagination__38wBY"};